import React, { useEffect, useState } from "react";
import { EllipsisOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useLocation } from "react-router-dom";
import {
  removeReportLoad,
  reportDetailLoad,
} from "../../../redux/slices/report.slice";
import { Popover, Modal } from "antd";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import images from "../../../themes/appImage"; // Adjust the path according to your project structure
import appconstant from "../../../themes/appconstant";
import { removeReportApi } from "../../../redux/Api/api";
import { imageURL } from "../../../redux/Api/apikit";

const validationSchema = Yup.object().shape({
  reason: Yup.string()
    .required("Please enter a reason to remove this post")
    .max(500, "Maximum 500 characters allowed"),
});

const ReportPost = () => {
  const dispatch = useDispatch();
  const [modal1Open, setModal1Open] = useState(false);
  const { state } = useLocation();

  const [open, setOpen] = useState(false);
  const [wordCount, setWordCount] = useState(0);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  useEffect(() => {
    if (state) {
      dispatch(reportDetailLoad(state));
    }
  }, [dispatch, state]);

  const reportData = useSelector((state) => state.ReportReducer?.reportDetail);
  const reportByData = reportData[0]?.reportBy;

  if (!reportData || reportData.length === 0) {
    return <div>Loading...</div>;
  }

  const handleSubmit = (values, { resetForm }) => {
    console.log("Form values:", values);
    console.log(reportData, "sdsdfsdf");
    values.reportId = reportData[0]._id;
    console.log("Form values:=", values);
    dispatch(removeReportLoad(values));
    resetForm();
    setModal1Open(false);
  };

  const handleWordCount = (value) => {
    setWordCount(value.length);
  };

  return (
    <div className="add-post-dis-mental-fit">
      <div className="community-page-width">
        <div className="gratitude-attitude-new-sec">
          <div className="problem-type-hate">
            <div className="hate-speech">
              <div className="problem-type">
                <p>Problem Type</p>
                <h1>{reportData[0].reason}</h1>
              </div>
              <div className="post-cont">
                <Popover
                  content={
                    <div className="popup" style={{ width: "200px" }}>
                      <div
                        onClick={() => {
                          setModal1Open(true);
                          setOpen(false);
                        }}
                        className="edit-account"
                      >
                        <p>
                          <span>
                            <img src={images.crossSquar} alt="crossSquar" />
                          </span>
                          Remove Post
                        </p>
                      </div>
                      {/* <div className="edit-account freeze-account">
                        <p>
                          <span>
                            <img src={images.rightClick} alt="rightClick" />
                          </span>
                          Ignore
                        </p>
                      </div> */}
                    </div>
                  }
                  title=""
                  trigger="click"
                  placement="right"
                  overlayClassName="update-popup fix-postion"
                  open={open}
                  onOpenChange={handleOpenChange}
                >
                  <img src={images.horizontalDots} alt="horizontalDots" />
                </Popover>
              </div>
            </div>
            <div className="annette-black-avatar">
              <div className="black-avatar">
                <p>
                  <span>
                    <img
                      src={`${imageURL}${reportByData.avatar}`}
                      alt="avatar"
                    />
                  </span>
                  {reportByData.userName}
                </p>
              </div>
              <div className="black-avatar-date">
                <p>{moment(reportByData.createdAt).utc().fromNow()}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-6">
          {reportData.map((report) => {
            const { _id, reportBy, postDetail } = report;
            const {
              userName: reportByUserName,
              avatar: reportByAvatar,
              createdAt: reportByCreatedAt,
            } = reportBy;
            const {
              text,
              file,
              postType,
              createdAt: postCreatedAt,
              createdBy,
            } = postDetail || {};
            const {
              userName: postUserName,
              avatar: createByAvatar,
              firstName,
              lastName,
            } = createdBy || {};
            const fileString = file ? `${imageURL}${file}` : null;

            return (
              <div
                key={_id}
                className="border border-royalPurple bg-white rounded-[20px] p-4 my-8"
              >
                <div className="flex gap-2 mb-2">
                  <div>
                    <img
                      src={`${imageURL}${createByAvatar}`}
                      alt="avatar"
                      className="w-[40px] h-[40px] object-contain rounded-full"
                    />
                  </div>
                  <div className="flex flex-col justify-between">
                    <div className="text-sm font-semibold text-dark">
                      {postUserName}
                    </div>
                    <div className="text-xs text-gray60 font-normal">
                      {moment(postCreatedAt).utc().fromNow()}
                    </div>
                  </div>
                  <div className="flex-grow" />
                  <div>{/* <EllipsisOutlined /> */}</div>
                </div>
                <div className="text-base font-normal break-words text-dark mb-4">
                  {text}
                </div>
                <div>
                  {postType === "textWithGIF" && fileString && (
                    <>
                      <img src={fileString} alt="gif" className="w-full" />
                    </>
                  )}
                  {postType === "gifOnly" && fileString && (
                    <img src={fileString} alt="gif" className="w-full" />
                  )}
                  {postType === "imageWithText" && fileString && (
                    <>
                      <img src={fileString} alt="image" className="w-full" />
                    </>
                  )}
                  {postType === "videoWithText" && fileString && (
                    <video width="600" controls>
                      <source src={fileString} type="video/mp4" />
                    </video>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        title=""
        className="modal-update"
        centered
        open={modal1Open}
        closable={true}
        onCancel={() => setModal1Open(false)}
        footer={false}
        width={600}
      >
        <Formik
          initialValues={{ reason: "", reportId: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="add-user-popup">
                <div className="modal-add-user">
                  <h1>Remove Post</h1>
                  <div className="user-disp">
                    <p>Please enter reason to remove this post</p>
                  </div>
                </div>
                <div className="wrapper_line">
                  <div className="form-group">
                    <div className="textarea-label">
                      <label>{appconstant.message}</label>
                      {/* <p>{wordCount}/500</p> */}
                    </div>
                    <Field
                      as="textarea"
                      rows="8"
                      cols="50"
                      className="form-control-textarea"
                      name="reason"
                      placeholder="Enter Description"
                      // onChange={(e) => {
                      // handleWordCount(e.target.value);

                      // }}
                    />

                    <ErrorMessage
                      name="reason"
                      component="div"
                      className="text-red-500 text-xs font-normal"
                    />
                  </div>
                </div>
              </div>
              <div className="click-to-upload problem-btn-mt">
                <div className="create-inner-circle-btn save-btn-mo">
                  <button type="submit">Send</button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default ReportPost;
